import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SpinnerHelper } from '../../../../helpers/spinner.helper';
import { ToastrHelper } from '../../../../helpers/toastr.helper';
import { ProjectAttendee } from '../../../../models/projects/project-attendee.model';
import { Project } from '../../../../models/projects/project.model';
import { RemoveAttendeeCommand } from '../../../../models/projects/remove-attendee-request';
import { ProjectsService } from '../../../../services/projects/projects.service';

@Component({
    selector: 'dialog-remove-attendee',
    templateUrl: './dialog-remove-attendee.component.html',
    styleUrls: ['./dialog-remove-attendee.component.scss'],
})
export class DialogRemoveAttendeeComponent {
    @Input() userToUpdate: ProjectAttendee;
    @Input() project: Project;
    @Input() visible = false;
    @Output() visibleChange = new EventEmitter<boolean>();
    constructor(
        private readonly projectsService: ProjectsService,
        private readonly spinnerHelper: SpinnerHelper,
        private readonly toastrHelper: ToastrHelper,
    ) {}

    public toggleRemoveUserModal(profile: ProjectAttendee) {
        this.userToUpdate = profile;
        this.visible = !this.visible;
    }

    public removeAttendeeFromProject(profile: any) {
        this.spinnerHelper.showSpinner();

        const command = new RemoveAttendeeCommand(this.project, profile.id);

        this.projectsService.RemoveAttendeeFromProject(command).subscribe(
            () => {
                this.toastrHelper.showSuccess("L'utilisateur a bien été retirer du projet");
                this.project.attendees = this.project.attendees.filter((attendee) => attendee.id !== profile.id);
            },
            (error) => {
                this.toastrHelper.showGenericError(error);
            },
            () => {
                this.spinnerHelper.hideSpinner();
                this.toggleRemoveUserModal(null);
                this.visibleChange.emit(false);
            },
        );
    }
}
